export default {
    imageAIFormRules: {
        enterDescription: 'Por favor, introduza a descrição.',
        invalidDescription: 'Por favor, introduza uma descrição válida.',
        enterNumberOfVariations: 'Por favor, selecione o número de variação.',
        invalidNumberOfVariations: 'You can generate maximum 4 and minimum 1 variation',
        enterStyle: 'Please select at least one style',
    },
};
